$('body').on('click', '.prodCta button', function(e) {
    // adding preventDefault to avoid redirect to cart (not sure why that happens on click though)
    e.preventDefault();
    var itemToAdd = $(this).data('variant');
    console.log('itemToAdd', itemToAdd);
    // CartJS.addItem(itemToAdd, 1, {"Promotion": "Free gift for you"}, {
    CartJS.addItem(itemToAdd, 1, {}, {  
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
        $('body').trigger('added.ajaxProduct');
      },
      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log('failed');
        $('body').trigger('added.ajaxProduct');
      }
    });
});

var allowAutoRemoval = false;
var allowMoreThanOneUnit = false;

function checkGWP2021(data) {
  var hasgwptier1 = false, hasgwptier2 = false, container = document.querySelector('#gwp_module_container');
  var gwpProduct01 = container.dataset.gwp1, gwpProduct02 = container.dataset.gwp2;
  var checkCurrentValue = checkTier(data, gwpProduct01, gwpProduct02);
  var whatTier = 0;
  var textForMessage = '';

  // These are the GWP threshold values - should be in theme customizer but not right now
  var baseValue1 = 15000
  var baseValue2 = 40000
  
  var ammount1 = baseValue1 - checkCurrentValue;
  var ammount2 = baseValue2 - checkCurrentValue;
  ammount1 = ammount1/100;
  ammount2 = ammount2/100;
  if (ammount1 < 0) { ammount1=0; }
  if (ammount2 < 0) { ammount2=0; }
  	
  $( "#gwp_module_container" ).show();
  console.log(data);
  console.log('ammount1:::::' + ammount1);
  console.log('ammount2:::::' + ammount2);
  
  $.each(data.items, function(index, item) {
    if (item.handle == gwpProduct01) {
      hasgwptier1 = true;
    }
    if (item.handle == gwpProduct02) {
      hasgwptier2 = true;
    }
    if (item.handle == gwpProduct01 && item.quantity > 1 && allowMoreThanOneUnit) {
      CartJS.updateItemById(item.id, 1); 
      
     setTimeout(function(){ $('body').trigger('added.ajaxProduct');}, 2000);
    }
    if (item.handle == gwpProduct02 && item.quantity > 1 && allowMoreThanOneUnit) {
      CartJS.updateItemById(item.id, 1); 
      setTimeout(function(){ $('body').trigger('added.ajaxProduct');}, 2000);
      
    }
  });
  if (checkCurrentValue < baseValue2 && !hasgwptier1 && !hasgwptier2 ) { 
    textForMessage = "Add $"+ammount1+" to your cart for a free "+$(".productName02").text() + " and $"+ammount2+" to also get a "+$(".productName02").text();  
  }
  if (checkCurrentValue >= baseValue2 && !hasgwptier1 && !hasgwptier2 ) { 
    textForMessage = "Your order qualifies for a free "+$(".productName02").text() + " and a "+$(".productName02").text();
  }
  if (checkCurrentValue >= baseValue2 && hasgwptier1 && hasgwptier2 ) { 
    textForMessage = "";
  }
  
  // ES adding override if static messaging is set in theme customizer
  if (theme.settings.gwpSubtitleOverride.length > 0) {
  	textForMessage = theme.settings.gwpSubtitleOverride;
  } 
  
  $("#progressMessage").text(textForMessage);
  
  console.log("hasgwptier1: "+hasgwptier1+" hasgwptier2: "+hasgwptier2);
  if (hasgwptier1 && hasgwptier2){
    //$( "#gwp_module_container" ).hide();
    $( ".gwp_module_product_tier1" ).addClass( "disabled" );
    $( ".gwp_module_product_tier2" ).addClass( "disabled" );
    $( "#progressMessage" ).hide();
    $( ".arrow.down" ).hide();
    
    console.log("hasgwptier1 && hasgwptier2");
    if (checkCurrentValue < baseValue1){
      if (allowAutoRemoval) {
      	removeItem(data, gwpProduct01);
      }
    }
    if (checkCurrentValue < baseValue2){
      if (allowAutoRemoval) {
      	removeItem(data, gwpProduct02);
      }
    }    
  }
  else {
    $( "#gwp_module_container" ).show();
    $( "#progressMessage" ).show();
    $( ".arrow.down" ).show();
    if (hasgwptier1){
      if (checkCurrentValue < baseValue1){
        console.log("condicion1-a");
        if (allowAutoRemoval) {
        	removeItem(data, gwpProduct01);
        }
        $( ".gwp_module_product_tier1" ).removeClass( "disabled" );
      }
      else {
        console.log("condicion1-b");
        $( ".gwp_module_product_tier1" ).addClass( "disabled" );
      }
    } 
    if (hasgwptier2){
      if (checkCurrentValue < baseValue2){
        console.log("condicion2a");
        if (allowAutoRemoval) {
        	removeItem(data, gwpProduct02);
        }
        $( ".gwp_module_product_tier2" ).removeClass( "disabled" );
      }
      else{
        console.log("condicion2b");
        $( ".gwp_module_product_tier2" ).addClass( "disabled" );
      }
    }
    if (!hasgwptier1){
      if (checkCurrentValue < baseValue1){
        console.log("condicion3-a");
        $( "#Tier1_cta_erik" ).prop('disabled', true).html('Almost There');
        $( ".gwp_module_product_tier1" ).removeClass( "disabled" ); 
      }
      else {
        console.log("condicion3-b");
        $( "#Tier1_cta_erik" ).prop('disabled', false).html('Redeem Now');
        $( ".gwp_module_product_tier1.disabled" ).removeClass( "disabled" );
      };   
    } 
    if (!hasgwptier2){
      if (checkCurrentValue < baseValue2){
        console.log("condicion4a");
        $( "#Tier2_cta_erik" ).prop('disabled', true).html('Almost There');
        $( ".gwp_module_product_tier2" ).removeClass( "disabled" );
      }
      else{
        console.log("condicion4b");
        $( "#Tier2_cta_erik" ).prop('disabled', false).html('Redeem now');
        $( ".gwp_module_product_tier2" ).removeClass( "disabled" );
      }
    }
  }  
}
function removeItem (data, gwpProduct){
  console.log(data);
  for (var i = 0; i < data.items.length; i++ ){
  	if (data.items[i].handle == gwpProduct) {    
      CartJS.removeItemById(data.items[i].id, {
          "success": function(data, textStatus, jqXHR) {
              $('body').trigger('added.ajaxProduct');
            console.log("remove: "+gwpProduct);
          },
          "error": function(jqXHR, textStatus, errorThrown) {
              alert('Error: ' + errorThrown + '!');
          }
      });     
    }
  }
}
function checkTier(data, gwpProduct01, gwpProduct02){
  var currentCartValue = data.total_price, gwp1Val = 0, gwp2Val = 0, currentTier = 0;
  for (var i = 0; i < data.items.length; i++ ){
    if (data.items[i].handle == gwpProduct01) {
      gwp1Val = data.items[i].final_price;
    }
    if (data.items[i].handle == gwpProduct02) {
      gwp2Val = data.items[i].final_price;
    }
  } 
  currentCartValue = (currentCartValue - gwp1Val) - gwp2Val;
  console.log("gwp1Val::::: "+gwp1Val+" gwp2Val::: "+gwp2Val+" currentCartValue::: "+currentCartValue);
  return currentCartValue;
}

$('body').on('click', '.gwp_module_products .variant-input', function() {
  console.log("click-----");
  var selectedOption1 = {option1: $("#ProductSelect-product01").find(':selected').data('option1'), option2:$("#ProductSelect-product01").find(':selected').data('option2'), image:$("#ProductSelect-product01").find(':selected').data('image'), available:$("#ProductSelect-product01").find(':selected').data('available')};
  var selectedOption2 = {option1: $("#ProductSelect-product02").find(':selected').data('option1'), option2:$("#ProductSelect-product02").find(':selected').data('option2'), image:$("#ProductSelect-product02").find(':selected').data('image'), available:$("#ProductSelect-product02").find(':selected').data('available')};
  var optionName = $(this).data('index'), optionVal = $(this).data('value');
  var checkwhichParent = $(this).closest(".productOptionsContainer").attr('id');
  console.log("checkwhichParent-----"+ checkwhichParent);
  console.log(selectedOption1);
  console.log(selectedOption2);
  console.log(optionName);
  if (checkwhichParent == "prod01Container"){ 
    $("#prod01Container .variant__button-label").removeClass( "selected" );   
    selectedOption1[optionName]= optionVal;
    $("#ProductSelect-product01").find(':selected').removeAttr('selected');
    var list = ".opOne-" + selectedOption1.option1 + ".opTwo-"+ selectedOption1.option2;
    var newOptionId = $(list).val(), newOptionImage = $(list).data('image');
    if (newOptionImage) {
      $('#img-prod-01').attr('src', newOptionImage);
    }
    $("#ProductSelect-product01 option[value='" + newOptionId + "']").attr("selected","selected");
    $("#Tier1_cta_erik").attr("data-variant",newOptionId);
    $(this).children(".variant__button-label").addClass( "selected" );
    
  }
   if (checkwhichParent == "prod02Container"){
    $("#prod02Container .variant__button-label").removeClass( "selected" );
    selectedOption2[optionName]= optionVal;
    $("#ProductSelect-product02").find(':selected').removeAttr('selected');
    var list = ".opOne-" + selectedOption2.option1 + ".opTwo-"+ selectedOption2.option2;
    var newOptionId = $(list).val(), newOptionImage = $(list).data('image');
    if (newOptionImage) {
      $('#img-prod-02').attr('src', newOptionImage);
    }
    $("#ProductSelect-product02 option[value='" + newOptionId + "']").attr("selected","selected");
    $("#Tier2_cta_erik").attr("data-variant",newOptionId);
    $(this).children(".variant__button-label").addClass( "selected" );
  } 
});

$('body').on('change', 'select.gwp-select-option', function() {
  console.log('changed');
  console.log(this.value);
  console.log("click-----");
  var selectedOption1 = {option1: $("#ProductSelect-product01").find(':selected').data('option1'), option2:$("#ProductSelect-product01").find(':selected').data('option2'), image:$("#ProductSelect-product01").find(':selected').data('image'), available:$("#ProductSelect-product01").find(':selected').data('available')};
  var selectedOption2 = {option1: $("#ProductSelect-product02").find(':selected').data('option1'), option2:$("#ProductSelect-product02").find(':selected').data('option2'), image:$("#ProductSelect-product02").find(':selected').data('image'), available:$("#ProductSelect-product02").find(':selected').data('available')};
  var optionName = $(this).data('index'), optionVal = $(this).find(':selected').data('value');
  var checkwhichParent = $(this).closest(".productOptionsContainer").attr('id');
  console.log("checkwhichParent-----"+ checkwhichParent);
  console.log(selectedOption1);
  console.log(selectedOption2);
  console.log(optionName);
  console.log(optionVal);
  if (checkwhichParent == "prod01Container"){ 
    console.log('do this');
    $("#prod01Container .variant__button-label").removeClass( "selected" );   
    selectedOption1[optionName]= optionVal;
    $("#ProductSelect-product01").find(':selected').removeAttr('selected');
    var list = ".opOne-" + selectedOption1.option1 + ".opTwo-"+ selectedOption1.option2;
    console.log(list);
    console.log(selectedOption1);
    console.log(selectedOption2);
    var newOptionId = $(list).val(), newOptionImage = $(list).data('image'), newOptionAvailable = $(list).data('available');
    console.log(newOptionId);
    console.log(newOptionImage);
    console.log(newOptionAvailable);

    if (!newOptionAvailable) {
      console.log('not available');
      $( "#Tier1_cta_erik" ).prop('disabled', true).html('Not Available');
    } else {
      $( "#Tier1_cta_erik" ).prop('disabled', false).html('Redeem Now');
    }
      
    if (newOptionImage) {
      $('#img-prod-01').attr('src', newOptionImage);
    }
    $("#ProductSelect-product01 option[value='" + newOptionId + "']").attr("selected","selected");
    $("#Tier1_cta_erik").attr("data-variant",newOptionId);
    $(this).children(".variant__button-label").addClass( "selected" ); 
  }
  if (checkwhichParent == "prod02Container"){ 
    console.log('do this');
    $("#prod02Container .variant__button-label").removeClass( "selected" );   
    selectedOption2[optionName]= optionVal;
    $("#ProductSelect-product02").find(':selected').removeAttr('selected');
    var list = ".opOne-" + selectedOption2.option1 + ".opTwo-"+ selectedOption2.option2;
    console.log(list);
    console.log(selectedOption1);
    console.log(selectedOption2);
    var newOptionId = $(list).val(), newOptionImage = $(list).data('image'), newOptionAvailable = $(list).data('available');
    console.log(newOptionId);
    console.log(newOptionImage);
    console.log(newOptionAvailable);

    if (!newOptionAvailable) {
      console.log('not available');
      $( "#Tier2_cta_erik" ).prop('disabled', true).html('Not Available');
    } else {
      $( "#Tier2_cta_erik" ).prop('disabled', false).html('Redeem Now');
    }
      
    if (newOptionImage) {
      $('#img-prod-02').attr('src', newOptionImage);
    }
    $("#ProductSelect-product02 option[value='" + newOptionId + "']").attr("selected","selected");
    $("#Tier2_cta_erik").attr("data-variant",newOptionId);
    $(this).children(".variant__button-label").addClass( "selected" ); 
  }
  // if (checkwhichParent == "prod02Container"){
  //   $("#prod02Container .variant__button-label").removeClass( "selected" );
  //   selectedOption2[optionName]= optionVal;
  //   $("#ProductSelect-product02").find(':selected').removeAttr('selected');
  //   var list = ".opOne-" + selectedOption2.option1 + ".opTwo-"+ selectedOption2.option2;
  //   var newOptionId = $(list).val(), newOptionImage = $(list).data('image');
  //   if (newOptionImage) {
  //     $('#img-prod-02').attr('src', newOptionImage);
  //   }
  //   $("#ProductSelect-product02 option[value='" + newOptionId + "']").attr("selected","selected");
  //   $("#Tier2_cta_erik").attr("data-variant",newOptionId);
  //   $(this).children(".variant__button-label").addClass( "selected" );
  // } 
});

$('body').on('click', 'xx.gwp_module_products .variant-input', function() {

});



// Erik adding GWP edits on Nov 16 2021
//$('.gwp_module_header h4').click(function() {

$('body').on('click', '.gwp_module_header h4', function() {
    $( ".gwp_module_products" ).slideToggle( 400, function() {
        if ($( ".gwp_module_products" ).is(':hidden')) {
            console.log('closed');
            $('.gwp_module_header h4 i').removeClass('down').addClass('up');
            
        } else {
            console.log('open');
            $('.gwp_module_header h4 i').removeClass('up').addClass('down');
        }
    });
});


// Erik adding video modal for father's day 2022
$('document').ready(function() {
  var fathersDayVideo = {
    channel: 'vimeo',
    ratio: '23:41',
    vimeo: {
      autoplay: true,
      controls: true,
      height: null,
      loop: false,
      maxheight: null,
      maxwidth: null,
      muted: false,
      portrait: true,
      width: null,
    },
    allowFullScreen: false,
    allowAutoplay: true
  };
  var setVideoButton = new ModalVideo('.fathers-day-modal-btn', fathersDayVideo);
});

// Storyside adding utility function to get URL parameter in jquery
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

// Storyside adding function that will attempt to "click" option values after a product page loads if those values are in URL params (which we add to 100+ product swatch links in theme.js _storside function)
var clickOptionValue = function(option1, option2, option3) {

    var option1Name = option1;
    var option1Value = getUrlParameter(option1);
    var option2Name = option2;
    var option2Value = getUrlParameter(option2);
    var option3Name = option3;
    var option3Value = getUrlParameter(option3);

    $('[data-option-selector="option-' + option1Name + '-' + option1Value + '"]').click();
    $('[data-option-selector="option-' + option2Name + '-' + option2Value + '"]').click();
    $('[data-option-selector="option-' + option3Name + '-' + option3Value + '"]').click();
    
}

$(document).ready(function () {
  console.log('Storyside document ready, now click waist and inseam values if in URL');
  clickOptionValue('waist', 'inseam', 'size');
});
